export default "__VITE_ASSET__QghExemA__"